import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { PlatformModelsResponse } from "../models/platform-models-response";
import { TaskStatusResponse } from "../models/task-status-response";
import { AGENTS } from "../constants/enums";
import { KnowledgeTaskStatusResponse } from "../models/knowledge-task-status-response";
import { environment } from "../../../environments/environment";
import { AlertService } from "./alert.service";

@Injectable({
  providedIn: 'root'
})
export class UtilsService {

  token: string = '';
  moduleId: string = '';
  projectId: string = '';
  refactorId: string = '';

  constructor(
    private http: HttpClient,
    private alertService: AlertService
  ){}
  saveToken(token:string): void{
    this.token = token;
  }

  getToken(): string{
    return this.token;
  }

  setModuleId(moduleId: string): void {
    this.moduleId = moduleId;
  }

  getModuleId(): string {
    return this.moduleId;
  }

  setProjectId(projectId: string): void {
    this.projectId = projectId;
  }

  getProjectId(): string {
    return this.projectId;
  }

  setRefactorId(refactorId: string): void {
    this.refactorId = refactorId
  }

  getRefactorId(): string {
    return this.refactorId;
  }

  getAiModels(): Observable<PlatformModelsResponse>{
    const headers = {
      'Authentication': 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJmS1JlNkdSc2JKV0NCRHBkQnFGOEhVTVpjWjNjWGFkVSIsImlhdCI6MTc0NDIwODQ4NSwic3ViIjoiaW5ldHVtLXRlY2gtYW1zIn0.uhfa4b3hb04h1SH7HSdblKbmBA2HKC5cOEYsER1HO6s'
    }
    return this.http.post<PlatformModelsResponse>('https://inetum-genai-platform.swedencentral.cloudapp.azure.com/llm-proxy-ms/v1/models',{headers});
  }

  getTaskStatus(taskId: string, agent: string): Observable<TaskStatusResponse>{
    let url = '';
    let headers = new HttpHeaders();
    switch (agent) {
      case AGENTS.REFACTOR:
        url = environment.refactorApiUrl;
        break;
      case AGENTS.TESTPLAN:
        url = environment.testplanApiUrl;
        break;
      case AGENTS.UNITTEST:
        url = environment.unittestsApiUrl;
        headers = new HttpHeaders({
          'user-id': 'user1'
        });
        break;
      case AGENTS.ANALYSIS:
        url = `${environment.refactorApiUrl}/analysis`;
        break;
    }


    return this.http.get<TaskStatusResponse>(`${url}/tasks/${taskId}/status`, { headers });
  }
  getKnowledgeTaskStatus(taskId: string): Observable<KnowledgeTaskStatusResponse>{
    let url = environment.knowledgeApiUrl;
    return this.http.get<KnowledgeTaskStatusResponse>(`${url}/tasks/${taskId}/status`);
  }

  /**
   * Decodifica caracteres unicode escapados en un texto
   * @param text Texto con caracteres unicode escapados (ej: "b\u00fasqueda")
   * @returns Texto decodificado (ej: "búsqueda")
   */
  decodeUnicodeEscapes(text: string): string {
    if (!text) return text;
    return text.replace(/\\u([0-9a-fA-F]{4})/g, (_, hex) => String.fromCharCode(parseInt(hex, 16)));
  }

  async showPopover(type: string, title: string, message: string): Promise<void> {
    await this.alertService.showAlert({
      type: type as any,
      title,
      message
    });
  }
    
}
